import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./MusicHomeSearchControlResetButton.module.scss";
import {useMusicHomeSearchControlResetButtonLogic} from "./MusicHomeSearchControlResetButton.logic";

export const MusicHomeSearchControlResetButton: VoidFunctionComponent = () => {
  const {isResetButtonAvailable, handleSearchInputReset} = useMusicHomeSearchControlResetButtonLogic();
  if (!isResetButtonAvailable) {
    // not available, don't return
    return null;
  }
  return (
    <button
      className={s.cancelSearchButton}
      onClick={handleSearchInputReset}
    >Cancel
    </button>
  );
}
